<template>
    <div class="row">
        <div v-if="loading" class="col-md-12">
            <div class="callout callout-success disabled color-palette">
                <h4><i class="icon fa fa-clock-o"></i> Por favor, aguarde</h4>
                <p class="loading"><b></b>
                    O arquivo está sendo carregado</p>
            </div>
        </div>
        <div v-if="error" class="col-md-12">
            <div class="alert bg-red color-palette">
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                <h4><i class="icon fa fa-ban"></i> Ops, houve um erro!</h4>
                <p>
                    {{error}}</p>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <required /> <label class="label-required" :class="{'text-danger':errors.has('file')}">Arquivos</label>
                <input v-on:change="handleFileUpload()" :class="{'is-invalid':errors.has('file')}" name="file"
                    ref="file" accept=".pdf" v-validate="{required:true}" multiple="multiple" id="uploadFile"
                    class="form-control" type="file">
                <div class="invalid-feedback help-block error">{{errors.first('file')}}</div>
            </div>
        </div>
        <div class="col-md-12">
            <table class="table table-sm table-hover table-condensed">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Arquivo</th>
                        <th>Tamanho</th>
                        <th>Última modificação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(file, i) in request.arquivos" :key="`upload${i}`">
                        <td><a @click="removeFile(i)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a></td>
                        <td>{{file.name}}</td>
                        <td>{{((file.size / 1024) / 1024).toFixed(2)}} (mb)</td>
                        <td>{{formatDate(file.lastModifiedDate)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            request: {},
        },
        data() {
            return {
                loading: false,
                error: false
            }
        },
        methods: {
            handleFileUpload() {
                const itens = Array.from(this.$refs.file.files);
                itens.map(item => {
                    if (this.request.arquivos.findIndex(x => x.name === item.name) == -1) {
                        this.request.arquivos.push(item);
                    }
                })
                $('#uploadFile').val("");
            },
            removeFile(payload) {
                this.request.arquivos.splice(payload, 1);
                toastr({
                    title: 'Arquivo removido!',
                    icon: 'success'
                });
            },
        }
    }
</script>